module.exports = __webpack_public_path__ + "dimer/static/img/16.8182a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/16.jpg
// module id = nFc8
// module chunks = 0